<div *ngIf="items.length" class="filter-summary text-muted ml-3">
  Filters active:
  <ng-container *ngFor="let item of items; let last = last">
    {{ item.label }}
    <strong>{{ item.value }}</strong>
    <span *ngIf="!last"> AND </span>
  </ng-container>
</div>
